import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import formService from "../../services/forms/form.service";
import { AnketRequestDto } from "../../services/forms/form.dto";
import { useToast } from "../../utils/toast";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import VideoComponent from "../../components/VideoComponent";
import ProtokolFirmalarComponent from "../../components/ProtokolFirmalarComponent";
import adminService from "../../services/admin/admin.services";
import { VideoDto } from "../../services/admin/admin.dto";

const IsSurekliligi = () => {
  const toast = useToast();
  const [videos, setVideos] = useState<VideoDto[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<VideoDto | null>(null);

  const formik = useFormik<AnketRequestDto>({
    initialValues: {
      result1: ""
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.result1 || values.result1 === "") {
        errors.result1 = "Bir seçenek şeçiniz.";
      }

      return errors;
    },
    onSubmit: async (values) => {
      formService.afadAnket(values).then((res) => {
        if (res?.result?.error === null) {
          toast.show("Anket kaydedildi.", "success");
        } else {
          toast.show("Anket kaydedilemedi", "error");
        }
      });
    }
  });

  const options = [
    { label: "Evet", value: "evet" },
    { label: "Hayır", value: "hayir" }
  ];

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    const value = e.value;
    let newAnalysisAreas: string = "";

    if (e.checked) {
      newAnalysisAreas = value;
    }

    formik.setFieldValue("result1", newAnalysisAreas);
  };

  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const response = await adminService.getVideos("IS_SUREKLILIGI");
      if (response?.result?.data) {
        setVideos(response.result.data);
        // İlk video varsayılan olarak seçili olsun
        if (response.result.data.length > 0) {
          setSelectedVideo(response.result.data[0]);
        }
      }
    } catch (error) {
      console.error("Error loading videos:", error);
      toast.show("Video verilerini yüklerken bir hata oluştu.", "error");
    }
  };

  const handleVideoSelect = (video: VideoDto) => {
    setSelectedVideo(video);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {selectedVideo && (
        <VideoComponent videoUrl={selectedVideo.video_url} header={selectedVideo.title} autoplay={true} />
      )}

      {videos.length > 1 && (
        <div className="card">
          <div className="w-full surface-card">
            <div className="text-center mb-5">
              <div className="text-900 text-3xl font-medium mb-3">İş Sürekliliği Video Arşivi</div>
            </div>
          </div>
          <div className="justify-content-center">
            <div className="grid">
              {videos.map((video) => (
                <div className="col-12 md:col-6 lg:col-4" key={video.id}>
                  <div
                    className="cursor-pointer"
                    onClick={() => handleVideoSelect(video)}
                    style={{
                      border: selectedVideo?.id === video.id ? "2px solid var(--primary-color)" : "none",
                      borderRadius: "4px",
                      padding: "4px"
                    }}
                  >
                    <div className="relative">
                      <img
                        src={`https://img.youtube.com/vi/${video.video_url.split("v=")[1]}/mqdefault.jpg`}
                        alt={video.title}
                        style={{ width: "100%", borderRadius: "4px" }}
                      />
                      <div className="absolute bottom-0 left-0 right-0 p-3 bg-black-alpha-50">
                        <h3 className="text-white m-0 text-lg">{video.title}</h3>
                      </div>
                      <div className="absolute top-50 left-50 transform-center">
                        <i className="pi pi-play-circle text-white text-4xl"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="w-full surface-card">
          <div className="text-center mb-5">
            <div className="text-900 text-3xl font-medium mb-3">İş Sürekliliği Planı Anketi</div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-column align-items-start">
              <h5>OSB'nizin afetlerde üretime devam etmesi için bir planınız var mı?</h5>
              <div className="grid">
                {options.map((option) => (
                  <div key={option.value} className="col-12 ml-3">
                    <Checkbox
                      inputId={option.value}
                      value={option.value}
                      onChange={handleCheckboxChange}
                      checked={formik.values.result1.includes(option.value)}
                    />
                    <label htmlFor={option.value} className="ml-2">
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>

              {formik.errors.result1 && <div className="p-error">{formik.errors.result1}</div>}
              <Button label="Gönder" type="submit" className="mt-3" />
            </div>
          </form>
        </div>
      </div>

      <ProtokolFirmalarComponent />
    </>
  );
};

export default IsSurekliligi;
